/******* Angular Resourse *******/
import { Inject, Injectable } from '@angular/core';
import { BaseApi } from '@api/base/base.service';
import { HttpClient } from '@angular/common/http';
import { GeoFenceRequestBody } from '@core/types';

@Injectable()
export class GeoFence extends BaseApi {

    constructor(@Inject(HttpClient) protected http: HttpClient) {
        super(http);
    }

    /**
     * GET /geo-fence - get geo fence list
     * 
     * @param filter
     */
    public getGeofences(filter) {
        return this.find("geo-fence", filter);
    }

    /**
     * POST /geo-fence - save geo fence
     * 
     * @param {GeoFenceRequestBody} data
     */
    public createGeofences(data: GeoFenceRequestBody) {

        let method = "POST",
            url = "geo-fence",
            routeParams = {},
            urlParams = {},
            postBody = data;

        return this.request(method, url, routeParams, urlParams, postBody);
    }

    /**
     * PATCH /geo-fence/{id} - update geo fence
     * 
     * @param {string} id
     * @param {Partial<GeoFenceRequestBody>} data
     */
    public updateGeofence(id: string, data: Partial<GeoFenceRequestBody>) {

        let method = "PATCH",
            url = "geo-fence/:id",
            routeParams = { id },
            urlParams = {},
            postBody = data;

        return this.request(method, url, routeParams, urlParams, postBody);
    }

    /**
     * DELETE /geo-fence/{id} - delete geo fence
     * 
     * @param {string} id
     */
    public deleteGeofence(id: string) {

        let method = "DELETE",
            url = "geo-fence/:id",
            routeParams = { id },
            urlParams = {},
            postBody = {};

        return this.request(method, url, routeParams, urlParams, postBody);
    }
}